import { render, staticRenderFns } from "./ChartMajorItems.vue?vue&type=template&id=2ccd239f&"
import script from "./ChartMajorItems.vue?vue&type=script&lang=js&"
export * from "./ChartMajorItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports